jQuery(document).ready(function ($) {
	$('.popup').on('click', function (e) {
		e.preventDefault();
		return false;
	});

	$('.popup').magnificPopup({
		type: 'inline',
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-img-mobile mfp-fade',
		closeOnBgClick: true,
		removalDelay: 300,
		callbacks: {
			open: function () {
				let imgWidth = $(".mfp-content .popupSlider img").width();
				$(".mfp-content").width(imgWidth);

				setTimeout(function () {
					$(window).on('resize', adjustResize);
				}, 300);

				$(".mfp-content .popupSlider").slick({
					autoplay: true,
					autoplaySpeed: 3000,
					speed: 1000,
					arrows: false,
					dots: false,
					centerMode: true,
					centerPadding: '0px',
					pauseOnHover: false,
					fade: true,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					draggable: true,
				});
			},
			beforeClose: function () {
				$('.mfp-content .popupSlider').slick('unslick');
			},
		}
	});

	$(window).on('resize', adjustNavi);

	let scrollTimer;
	$(window).on("scroll touchmove", function () {
		clearInterval(scrollTimer);
		scrollTimer = setInterval(function () {
			adjustNavi();
			clearInterval(scrollTimer);
		}, 10);
	});
	adjustNavi();

	function commonEvent() {
		adjustResize();

		$('a.scroll').on('click', function () {
			let speed = 500;
			let href = $(this).attr("href");
			let target = (href === "#" || href === "") ? 'html' : $(href);
			let sa = $(window).width() > 980 ? 50 : $(window).width() > 719 ? 30 : 0;
			let position = target.offset().top - sa;
			$("html, body").animate({ scrollTop: position }, speed, "swing");
			return false;
		});

		let topBtn = $('#pagetop');
		topBtn.on('click', function () {
			$('body,html').animate({ scrollTop: 0 }, 500);
			return false;
		});
	}
	commonEvent();

	function adjustNavi() {
		// ナビゲーション調整のロジックをここに追加
	}

	$(window).on('resize', adjustResize);

	function adjustResize() {
		let windowWidth = $(window).width();

		if ($(".mfp-content .popupSlider img").length >= 1) {
			let imgWidth = $(".mfp-content .popupSlider img").width();
			$(".mfp-content").width(imgWidth);
		}
	}
	adjustResize();

});
